import { css } from 'lit';
export const tokenBalanceStyle = css `
  :host {
    width: fit-content;
  }
`;
//# sourceMappingURL=token-balance.style.js.map